import { api } from "../../../../components/axios";
import {
  AnswerType,
  BankPayload,
  BankQuestion,
  BankView,
  QuestionFlow,
} from "./questionBank";

const BASE_URL = "bx_block_survey/question_bank";

export type QuestionChanges = Partial<
  Pick<BankQuestion, "text" | "screen" | "position" | "active">
> & {
  answer_type?: AnswerType;
  answer_options?: string[];
};

export type NewQuestion = {
  screen: string;
  flow: QuestionFlow;
  text: string;
  answer_type: AnswerType;
  answer_options: string[];
};

const authHeaders = () => ({ token: localStorage.getItem("authToken") || "" });

export const fetchQuestionBank = async (view: BankView): Promise<BankPayload> => {
  const response = await api.get(BASE_URL, {
    headers: authHeaders(),
    params: { view },
  });
  return response.data.data;
};

export const updateBankQuestion = async (
  key: string,
  changes: QuestionChanges
): Promise<BankQuestion> => {
  const response = await api.put(
    `${BASE_URL}/${encodeURIComponent(key)}`,
    { question: changes },
    { headers: authHeaders() }
  );
  return response.data.data;
};

export const addBankQuestion = async (
  question: NewQuestion
): Promise<BankQuestion> => {
  const response = await api.post(
    BASE_URL,
    { question },
    { headers: authHeaders() }
  );
  return response.data.data;
};

export const removeBankQuestion = async (
  key: string
): Promise<BankQuestion | null> => {
  const response = await api.delete(`${BASE_URL}/${encodeURIComponent(key)}`, {
    headers: authHeaders(),
  });
  return response.data.data;
};

export const reorderBankQuestions = async (
  keys: string[]
): Promise<BankPayload> => {
  const response = await api.put(
    `${BASE_URL}/reorder`,
    { keys },
    { headers: authHeaders() }
  );
  return response.data.data;
};
